export default __webpack_public_path__ + "static/media/04.ccc9a700.jpg";